const str = `{HEADER}이용약관

{BODY_TITLE}1 – 콘텐츠 제작 및 재발행 원칙
비디오몬스터 서비스를 활용하여 만드는 저작물들은 유해성을 띄거나 불법적인 서비스의 홍보, 광고에 활용되지 않아야합니다.
또한 브랜드 솔루션 협의를 통하여 양 측의 약속과 이해가 없는 경우 비디오몬스터를 활용하여 제작한 저작물의 재판매를 엄격히 금합니다.

{BODY_TITLE}2 – 지적 재산
① 사용 및 배포의 권리를 완전히 가지고 있는 사용자가 직접 입력한 글과 사진, 비디오 클립 외에, videomonster.com 내의 모든 지적 재산은 (주)비디오몬스터,
그리고 그 파트너(협력사) 및 서비스 제공자의 재산입니다. 또한 사용자는 사용과 배포에 있어 완전한 권리를 가지지 않는 콘텐츠를 비디오몬스터에 업로드 하지않는 것을 원칙으로 합니다.
{ADD_LINE}
② 저작물이 "정보통신망법" 및 "저작권법"등 관련법에 위반되는 내용을 포함하는 경우, 권리자는 소명자료(권리자임을 소명하는 자료와 권리침해사실을 소명하는 자료)를 첨부하여 이메일 또는 우편으로 비디오몬스터에 해당 저작물의 게시중단 및 삭제 등을 요청할 수 있습니다.
{ADD_LINE}
③ 비디오몬스터는 권리자에게 진행상황을 통지하고 관련법에 따라 조치를 취합니다. 비디오몬스터가 필요한 조치를 한 경우 이 사실을 신청인과 정보게재자에게 통지하고, 해당 게시판 또는 서비스 초기화면에 공시하는 등의 방법으로 이용자가 알 수 있도록 합니다.
{ADD_LINE}
④ 비디오몬스터는 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련법에 위반되는 경우에는 관련법에 따라 해당 저작물에 대해 접근을 임시적으로 차단하는 조치(이하 ‘임시조치’라 합니다) 등을 취할 수 있습니다.
{ADD_LINE}
⑤ 비디오몬스터는 제2항에 따른 정보의 삭제요청에도 불구하고 권리의 침해 여부를 판단하기 어렵거나 이해당사자 간에 다툼이 예상되는 경우에는 30일 이내의 기간을 정하여 해당 정보에 임시조치를 할 수 있습니다.

{BODY_TITLE}3 – 지불
비디오몬스터 서비스는 영상 한편 개별 과금과 월 정기 결제가 가능합니다.
결제에 관련한 자세한 정보는 결제 페이지를 확인해주시고 별도의 문의사항은 비디오몬스터 채팅, 대표 번호, 이메일 등을 이용하여 자유롭게 문의해주세요.
비디오몬스터는 사용자의 개인정보를 보호하기 위하여 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 그리고 개인정보 보호법 등 관계 법령에서 정해진 바를 준수합니다.
개인정보의 보호 및 사용에 대해서는 관련 법령 및 비디오몬스터의 개인정보취급방침이 적용됩니다.
{ADD_LINE}
비디오몬스터는 사용자의 개인정보를 보호하기 위하여 개인정보취급방침을 제정, 웹사이트 초기화면에 게시합니다. 다만, 개인정보취급방침의 구체적 내용은 연결화면을 통해 볼 수 있습니다.
{ADD_LINE}
비디오몬스터는 이용계약을 위하여 사용자가 제공한 정보를 비디오몬스터의 서비스 운영을 위한 목적 이외의 용도로 사용하거나 사용자의 동의 없이 제3자에게 제공하지 않습니다.
{ADD_LINE}
당사는 사용자의 개인 정보를 귀하의 신상정보, 귀하의 지불 내역, 귀하가 비디오를 제작하기 위해 비디오몬스터에 제출한 콘텐츠(텍스트, 사진, 비디오 클립 등)로 정의합니다.
{ADD_LINE}
이는 당사의 서버에 귀하의 개인 정보를 저장하는 절차까지 포함됩니다. 또한, 자동(컴퓨터 프로세스)이나 수동(사람이 직접 처리하는)의 방법 모두를 이용하여, 귀하가 제작하신 비디오 파일의 품질을 점검하는 것 역시 포함됩니다.
{ADD_LINE}
당사의 서버는 국제 네트워크를 기반으로 합니다. 따라서 비디오몬스터를 이용함으로써 귀하는 귀하의 데이터를 전 세계의 당사 서버에 저장하는 것에 동의하는 것이 됩니다. 현재 당사의 서버는 미국, 일본, 그리고 대한민국에 있으며, 이후에는 남미, 홍콩, 그리고 추후 결정되는 다른 여러 나라에도 추가적으로 서버를 확충할 계획입니다.

{BODY_TITLE}4 – 개인 정보 보호
비디오몬스터는 데이터 및 비디오몬스터 서비스 및 관련 기술의 이용 및 성과와 관련한 다른 정보를 수집, 이용 및 분석할 수 있고, 그것을 사업적으로 이용하거나 사업과 관련하여 통계적 또는 식별 불가능한 형태로 공개할 수 있습니다. 여러분의 어떤 정보가 수집 및 이용되는지는 개인정보 취급방침을 통하여 보다 많은 정보를 확인할 수 있습니다.

{BODY_TITLE}5 – 공유
사용자께서 비디오몬스터에서 제작한 영상 중 비디오몬스터 자체제작 템플릿은 사적 용도로 자유롭게 공유가능하며 상업적 용도(광고용 소재 활용 등)로도 자유롭게 활용하실 수 있습니다.
템플릿 셀렉샵에서 선택하여 제작하신 영상의 경우 일부 다른 규정이 적용될 수 있으며 이는 특정 샵에 고시하도록 하겠습니다.

{BODY_TITLE}6 – 제 3자 서비스
비디오몬스터에는 사용자 경험 일부에 포함되는 여러 제 3자 서비스가 존재합니다. 비디오몬스터를 이용함으로써, 사용자는 이러한 별도의 제 3자 서비스의 약관에도 동의하게 됩니다.
비디오몬스터에서 이용되는 제 3자 서비스는 지불 절차(이니시스 등), Facebook 등을 포함합니다.

{BODY_TITLE}7 – 제한적 보증
(주)비디오몬스터는 사용자에게 제한적 보증을 제공해드립니다.
비디오몬스터에서 사용자에 의해 제작된 비디오는 결함이 없어야 함을 원칙으로 합니다.
만약 사용자에 의해 제작된 비디오가 결함이 있을 경우, 비디오몬스터는 무료로 다시 제작할 수 있도록 대체해 드릴 것입니다.
결함은 귀하에 의해 제작된 글의 오자(오타)를 포함하지 않으며, 다만 당사에 의해 만들어진 글의 오자(오타)는 포함하기로 합니다.
또한, 결함의 범위는 사용자에 의해 제공된 사진이나 비디오 클립 자체의 문제는 해당되지 않으며, 다만 그 외 사진이나 비디오 시퀀스에 따르는 문제, 렌더링 과정의 오류로 발생한 문제,
즉 비디오몬스터의 잘못으로 발생한 문제들은 결함에 포함됩니다. 비디오몬스터는 최고의 서비스를 최적의 가격으로 제공할 수 있도록 항상 고민하고 있습니다.
제한적 보증에 대한 이의나 질문이 있으실 경우 당사 고객센터나 이메일(hello@videomonster.com), 대표번호 등으로 연락주세요!

{BODY_TITLE}8 – 면책, 제한적 법적책임
위의 제한적 보증에서 진술하는 바 이외에, 비디오몬스터의 전적인 책임 범위는 사용자가 지난 365일 이내에 비디오몬스터에 지불한 전체 금액을 초과하지 않는다는 것에 사용자가 동의함을 원칙으로 합니다.
만약, 사용자가 지난 365일 내에 비디오몬스터에 어떠한 요금도 지불하지 않았다면, 귀하에 대한 비디오몬스터의 전체책임은 1,000원을 초과 하지 않습니다.
비디오몬스터가 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는, 서비스 제공에 대한 책임이 면제됩니다.
비디오몬스터는 사용자의 귀책사유로 인한 서비스 이용 장애에 대해서는 책임을 지지 않습니다.

{BODY_TITLE}9 – 분쟁 해결
비디오몬스터는 사용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상 처리하기 위해서 피해보상처리 기구를 설치, 운영합니다.
비디오몬스터는 사용자가 제기하는 불만사항 및 의견을 우선하여 처리합니다. 다만 신속한 처리가 곤란한 경우에는 사용자에게 그 사유와 처리일정을 즉시 통보합니다.

{BODY_TITLE}10 - 준거법 및 관할법원
이 약관의 해석 및 비디오몬스터와 사용자 간의 분쟁에 관해서는 대한민국의 법령을 적용합니다.
비디오몬스터 서비스 이용 중 발생한 비디오몬스터와 사용자 간의 소송은 서울중앙지방법원에 제소합니다.
{FOOTER}
{FOOTER_SUB}이 약관은 2019년 5월 5일부터 적용됩니다.
`

export default str